var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCowPig = function SvgCowPig(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9540_10938)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 6.6086C10 5.71398 9.51538 4.92258 8.75385 4.50968C9.27308 3.82151 9.65385 2.9957 9.65385 2.03226C9.65385 1.68817 9.65385 1.34409 9.48077 1V1.03441C9.06538 2.68602 7.54231 3.75269 5.81154 3.75269H5.18846C3.45769 3.75269 1.9 2.68602 1.51923 1.03441V1C1.34615 1.34409 1.34615 1.68817 1.34615 2.03226C1.34615 2.9957 1.72692 3.82151 2.24615 4.54409C1.48462 4.95699 1 5.71398 1 6.6086C1.55385 6.6086 2.07308 6.40215 2.48846 6.09247L2.86923 9.18925C2.97308 10.0151 3.66538 10.6 4.49615 10.6H6.50385C7.33462 10.6 8.02692 9.98065 8.13077 9.18925L8.51154 6.09247C8.92692 6.43656 9.44615 6.6086 10 6.6086Z",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.4751 8.65039H7.6751",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2932 13.4707V13.4746",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7345 9V11.1251C11.043 11.5253 10.5164 12.1586 10.2493 12.9116H9.49992C9.35171 12.9116 9.20958 12.9704 9.10479 13.0752C8.99999 13.18 8.94112 13.3222 8.94112 13.4704V14.588C8.94112 14.7362 8.99999 14.8783 9.10479 14.9831C9.20958 15.0879 9.35171 15.1468 9.49992 15.1468H10.2498C10.4378 15.6778 10.7564 16.1531 11.1763 16.5287V17.6613C11.1763 17.8836 11.2646 18.0968 11.4218 18.254C11.579 18.4112 11.7922 18.4995 12.0145 18.4995C12.2368 18.4995 12.45 18.4112 12.6072 18.254C12.7644 18.0968 12.8527 17.8836 12.8527 17.6613V17.3356C13.0374 17.3665 13.2243 17.382 13.4115 17.3819H15.6467C15.8339 17.382 16.0208 17.3665 16.2055 17.3356V17.6613C16.2055 17.8836 16.2938 18.0968 16.451 18.254C16.6082 18.4112 16.8214 18.4995 17.0437 18.4995C17.266 18.4995 17.4792 18.4112 17.6364 18.254C17.7936 18.0968 17.8819 17.8836 17.8819 17.6613V16.5438V16.5287C18.3882 16.076 18.7451 15.4803 18.9053 14.8203C19.0656 14.1604 19.0216 13.4673 18.7793 12.8329C18.537 12.1985 18.1078 11.6526 17.5484 11.2675C16.989 10.8824 16.3258 10.6763 15.6467 10.6764H14.2497L11.7351 9H11.7345Z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9540_10938"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCowPig);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "cowPig.8a6983b2f4c53ee0962fc229b7831733.svg";